import React from 'react';
import './App.css';
import Hide from './components/Hide';

function App() {
  return (
    <div className="App">
      <Hide/>
    </div>
  );
}

export default App;
